<template>
  <div>
    <h4>Unban</h4>
    <template v-if="unban !== null">
      <table
        class="prop-table mb-4"
      >
        <tr>
          <th>Id</th>
          <td>{{unban.id}}</td>
        </tr>
        <tr>
          <th>Unbanner</th>
          <td>
            <user-link
              :user="unban.user"
            />
          </td>
        </tr>
        <tr>
          <th>Time</th>
          <td>{{unban.ctime | getMomentMinStr}}</td>
        </tr>
      </table>

      <p class="prop-lable">Reason</p>
      <p>
        {{unban.reason}}
      </p>
    </template>

    <loading-indicator
      v-if="isLoading"
    />

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import UserLink from './UserLink.vue';

export default {
  name: 'PlayerUnban',

  components: {
    LoadingIndicator,
    UserLink,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    unbanId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      unban: null,
    };
  },

  created() {
    notifier.deleteSenderNotifications(this);

    this.isLoading = true;

    const url = `/player/${this.playerId}/unban/${this.unbanId}`;
    HTTP.get(url)
    .then(response => {
      this.isLoading = false;

      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.');
        return;
      }

      this.unban = data;
    })
    .catch(e => {
      this.isLoading = false;
      notifier.showError(e.response.data, {sender: this});
    });
  },
};
</script>
